/**
 * Share text through the system sheet (Web Share API); browsers without it (most desktops) open WhatsApp with the text
 * prefilled (docs/UX-PLAYBOOK.md §6.6). Returns what happened so the caller can say so.
 */
export async function shareText(title: string, text: string): Promise<'shared' | 'cancelled' | 'whatsapp'> {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, text })
      return 'shared'
    } catch (e) {
      if (e instanceof DOMException && e.name === 'AbortError') return 'cancelled'
      // NotAllowedError and friends: fall through to WhatsApp
    }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer')
  return 'whatsapp'
}
